import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";

import Newreceivedapplication from "../../../ReceivedApp/Newreceivedapplication";
import JobListingHome from "../../../JobListing/JobListingHome";
import InterviewHome from "../../../Interview/interviewHome";
import Docs from "../../../Docs/Docs";
import { useTheme } from "../../../../style/theme";
import Departments from "../../EmployeeInformation/Departments";
import GettingStartedModal from "../../../Dashboard/MySpace/GettingStartedModal";
import TrialEndModal from "../../../../components/TrialEndModal";

export default function Recruit() {
  const [step, setStep] = useState(0);
 const [trialEndOpen, setTrialEndOpen] = useState(false);
  const org = JSON.parse(localStorage.getItem("org"));
  console.log(org?.plan, "planplanplan");


  let currentSubscription = JSON.parse(localStorage.getItem("subscription"));

  const permissions = currentSubscription?.plan?.permission || [];
  console.log(permissions, "orgorgorg");

  // let includedStarterPermissions = ["document_management"];

  const hasPermission = (permissionName) => {
    return permissions.some(
        (permission) => permission.key === permissionName && permission.isPermission
    );
};

  const { mode } = useTheme();
  const [switchScreen, setSwitchScreen] = useState({
    primary: "receivedapplications",
  });
  const primaryTabs = [
    {
      label: "Received Applications",
      value: "receivedapplications",
    },
    {
      label: "Job Listing",
      value: "jobListing",
    },
    {
      label: "Interview Questions",
      value: "interviewQuestions",
    },
     {
      label: "Docs ",
      value: "docs",
      permissionKey: "document_management",
    },
    {
      label: "Departments ",
      value: "departments",
    },
  ].filter(Boolean);  
  



  return (
    <Box
      sx={{ backgroundColor: mode == "light" ? "#f7f9fc" : "" }}
      className="w-full flex flex-col gap-3 h-full"
    >
      <div>
      <Tabs
  value={switchScreen.primary}
  onChange={() => {}} // Disable default behavior
  textColor="primary"
  variant="scrollable"
  scrollButtons="auto"
  indicatorColor="primary"
  aria-label="Navigation Tabs"
  sx={{
    minHeight: "32px",
  }}
  className="w-full sm:w-auto"
  TabIndicatorProps={{
    sx: {
      display: "none",
    },
  }}
>
  {primaryTabs.map((tab, index) => {
    const isSelected = tab.value === switchScreen.primary;

    const handleTabClick = () => {
      if (tab.permissionKey && !hasPermission(tab.permissionKey)) {
        // ❌ No permission → Open modal
        setTrialEndOpen(true);
      } else {
        // ✅ Has permission → Update tab
        setSwitchScreen({ primary: tab.value });
      }
    };
            return (
              <Tab
              key={index}
              value={tab.value}
              label={
                <span className="relative inline-block">
                  {tab.label}
                  {isSelected && (
                    <span
                      className="absolute left-0 -bottom-1.5 h-[2px] bg-blue-600 w-full"
                      style={{ borderRadius: 1 }}
                    />
                  )}
                </span>
              }
              className="h-8 text-xs sm:text-sm px-2 sm:px-4"
              onClick={handleTabClick}
              sx={{
                minWidth: "60px",
                padding: "4px 8px",
                fontSize: { xs: "10px", sm: "14px" },
                textTransform: "none",
                color: isSelected ? "#1976d2" : undefined,
              }}
            />
          );
        })}
      </Tabs>
      </div>
      {switchScreen.primary === "receivedapplications" && (
        <>
          <Newreceivedapplication />
        </>
      )}
      {switchScreen.primary === "jobListing" && (
        <>
          <JobListingHome />
        </>
      )}
      {switchScreen.primary === "interviewQuestions" && (
        <>
          <InterviewHome />
        </>
      )}

      {hasPermission("document_management") &&
        switchScreen.primary === "docs" && (
          <>
            <Docs />
          </> 
        )}

      {switchScreen.primary === "departments" && (
        <>
          <Departments />
        </>
      )}

              <TrialEndModal open={trialEndOpen} onClose={() => setTrialEndOpen(false)} />
       
    </Box>
  );
}
